import React, { useEffect } from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import "../css/list-place.css"
import rightArrow from "../assets/images/listing-place/right-arrow.png"
import awesomeCheck from "../assets/images/listing-place/awesome-check.png"
import heroImg from "../assets/images/listing-place/hero-image.png"
import heroImgMob from "../assets/images/listing-place/hero-image-mob.png"
import waveHeader from "../assets/images/listing-place/wave_header.png"
import leaseEnds from "../assets/images/listing-place/lease-ends.svg"
import arrowIcon from "../assets/images/listing-place/arrow_icon.png"
import leaseApartment from "../assets/images/listing-place/list-apartment.png"
import tenantFound from "../assets/images/listing-place/tenant-found.png"
import getPaid from "../assets/images/listing-place/get-paid.png"
import videoLine from "../assets/images/listing-place/video-line.png"
import videoActual from "../assets/videos/Ever-green.mp4"
import waveVideo from "../assets/images/listing-place/wave_video.svg"
import winnerLine1 from "../assets/images/listing-place/winner-line-1.png"
import winnerLine2 from "../assets/images/listing-place/winner-line-2.png"
import winnerLineBg1 from "../assets/images/listing-place/winner-bg-img-1.png"
import winnerLineBg2 from "../assets/images/listing-place/winner-bg-img-2.png"
import winnerLineBg3 from "../assets/images/listing-place/winner-bg-img-3.png"
import "aos/dist/aos.css"
import AOS from "aos"
import { graphql } from "gatsby"

const ListingPlace = ({ data }) => {
  const {
    strapiListingAPlace: { main_heading, main_points },
  } = data

  useEffect(() => {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 100,
      throttleDelay: 99,
      offset: 120,
      delay: 0,
      duration: 1200,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    })
  }, [])

  return (
    <Layout>
      <Seo Sitetitle="Listing a place" />
      <>
        <section className="hero-section">
          <div className="container-fluid">
            <div className="row flex-column-reverse-mob">
              <div data-aos="fade-up" className="col-lg-6 add-padding-to-col">
                <h2 className="top-wraper-navigation">
                  Home
                  <img
                    src={rightArrow}
                    className="img-fluid mx-2"
                    alt="right-arrow"
                  />
                  <b className="font-weight-bold">
                    For Students - I'm Listing a Place
                  </b>
                </h2>
                <h2 className="hero-heading mt-3">{main_heading}</h2>
                {main_points.map((item, index) => {
                  return (
                    <p className="hero-para" key={index}>
                      <img
                        src={awesomeCheck}
                        className="img-fluid"
                        alt="awesome-check"
                      />
                      {item.main_points}
                    </p>
                  )
                })}
                <button className="btn btn-wraper">list my place</button>
                <div className="hero-hr" />
              </div>
              <div
                data-aos="fade-right"
                className="col-lg-6 adjust-column pr-lg-0"
              >
                <img
                  src={heroImg}
                  className="img-fluid full-widht-mob hide-img-mob"
                  alt="hero"
                />
                <img
                  src={heroImgMob}
                  className="img-fluid d-sm-none w-100"
                  alt="hero"
                />
                <img
                  src={waveHeader}
                  className="img-fluid wave-header"
                  alt="wave_header"
                />
              </div>
            </div>
          </div>
          <img
            src={waveHeader}
            className="img-fluid wave-header hide-form-mob"
            alt="wave_header"
          />
        </section>
        <section className="wasys">
          <h2 data-aos="fade-left" className="rb2 space-left">
            Let’s put it this way
          </h2>
          <div className="container-fluid mt-lg-5">
            <div className="row">
              <div data-aos="fade-up" className="col">
                <div className="img-outer">
                  <img src={leaseEnds} className="img-fluid" alt="lease-ends" />
                </div>
                <h2 className="ways-heading">
                  Taylor’s lease ends in 6 months
                </h2>
              </div>
              <div data-aos="fade-left" className="col-lg-1 text-center">
                <img
                  src={arrowIcon}
                  className="img-fluid arrow_icon"
                  alt="arrow"
                />
              </div>
              <div data-aos="fade-down" className="col">
                <div className="img-outer">
                  <img
                    src={leaseApartment}
                    className="img-fluid"
                    alt="list-apartment"
                  />
                </div>
                <h2 className="ways-heading">
                  Taylor lists her apartment on Undorm
                </h2>
              </div>
              <div data-aos="fade-right" className="col-lg-1 text-center">
                <img
                  src={arrowIcon}
                  className="img-fluid arrow_icon"
                  alt="arrow"
                />
              </div>
              <div data-aos="fade-up" className="col">
                <div className="img-outer">
                  <img
                    src={tenantFound}
                    className="img-fluid"
                    alt="tenant-found"
                  />
                </div>
                <h2 className="ways-heading">
                  The next tenant is <br /> found
                </h2>
              </div>
              <div data-aos="fade-left" className="col-lg-1 text-center">
                <img
                  src={arrowIcon}
                  className="img-fluid arrow_icon"
                  alt="arrow"
                />
              </div>
              <div data-aos="fade-down" className="col">
                <div className="img-outer">
                  <img src={getPaid} className="img-fluid" alt="get-paid" />
                </div>
                <h2 className="ways-heading">Taylor gets paid $$$</h2>
              </div>
            </div>
          </div>
        </section>
        <section className="position-relative">
          <h2 data-aos="fade-down" className="video-heading rb2">
            <img src={videoLine} className="img-fluid" alt="line" />
            <span>
              Still unclear? <br /> Check out the video.
            </span>
          </h2>
          <div data-aos="fade-right" className="d-flex set-z-index mt-4">
            <div className="video-outer">
              <video width="100%" autoPlay muted loop>
                <source src={videoActual} type="video/mp4" />
              </video>
            </div>
          </div>
          <img
            data-aos="fade-up"
            src={waveVideo}
            className="img-fluid wave-video"
            alt="wave_video"
          />
        </section>
        <section className="winner">
          <div className="winner-inner">
            <div className="winner-top-box">
              <img
                data-aos="fade-left"
                src={winnerLine1}
                className="img-fluid"
                alt="line"
              />
              <h2
                data-aos="fade-up"
                className="d-inline-block winner-text ml-2"
              >
                We help connect students <br /> moving out of apartments <br />{" "}
                with students moving into <br /> them.
              </h2>
            </div>
            <div className="winner-main-txt-outer">
              <img
                data-aos="fade-right"
                src={winnerLine2}
                className="img-fluid"
                alt="line"
              />
              <h2 data-aos="fade-down" className="rb2  mt-sm-4 mt-3">
                Everyone’s a winner!
              </h2>
            </div>
          </div>
          <div className="winner-boxes-outer">
            <div className="container-fluid">
              <div className="row">
                <div data-aos="fade-down" className="col-md-4 col-sm-6">
                  <div className="winner-img-outer">
                    <div className="img-outer-padding">
                      <img
                        src={winnerLineBg1}
                        className="img-fluid"
                        alt="lines background"
                      />
                      <h2 className="winner-img-txt">YOU</h2>
                    </div>
                  </div>
                  <p className="winner-para text-center">
                    Make money when <br /> the next renter is <br /> found
                  </p>
                </div>
                <div data-aos="fade-left" className="col-md-4 col-sm-6">
                  <div className="winner-img-outer">
                    <div className="img-outer-padding">
                      <img
                        src={winnerLineBg2}
                        className="img-fluid"
                        alt="circle"
                      />
                      <h2 className="winner-img-txt black-txt">they</h2>
                    </div>
                  </div>
                  <p className="winner-para text-center">
                    Secure a place <br /> months in advance
                  </p>
                </div>
                <div
                  data-aos="fade-up"
                  className="col-md-4 col-sm-6 winner-box-col-3"
                >
                  <div className="winner-img-outer">
                    <div className="img-outer-padding">
                      <img
                        src={winnerLineBg3}
                        className="img-fluid"
                        alt="circle"
                      />
                      <h2 className="winner-img-txt">land lord</h2>
                    </div>
                  </div>
                  <p className="winner-para text-center">
                    Gets a new tenant <br /> with no downtime
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="list-appartment text-center">
          <p
            data-aos="fade-right"
            className="list-appartment-para text-capitalize"
          >
            Ready to List your Apartment?
          </p>
          <button data-aos="fade-up" className="btn btn-wraper mt-0">
            List on undorm
          </button>
        </section>
      </>
    </Layout>
  )
}

export const query = graphql`
  {
    strapiListingAPlace {
      main_heading
      main_points {
        main_points
      }
    }
  }
`

export default ListingPlace
